export default __webpack_public_path__ + "static/media/editing-services.beadc0c3.jpg";